export default "__VITE_ASSET__DUJwXW6x__"